/**
 * 换版本以后旧页面取不到分包：自动刷新一次（UI-STALE-CHUNK-RELOAD-01，6c2b 10-13；UI 总账 S-084、N-08）。
 *
 * 新版本上线后，开着旧页面的人点进还没加载过的页面，浏览器去取旧版本的分包，文件已经不在了，页面就白屏或停在出错页。
 * Vite（8.3.0）的预加载助手在两种情况下都会在 window 上发可取消的 vite:preloadError：分包预加载失败，以及动态导入本身失败。
 * 不取消就照常抛错，交给路由出错页（RouteErrorPage 有手动「刷新」）。
 *
 * 这里收到就刷新一次，刷新以后取到的就是新版本：
 * - 记下这次刷新的时刻（会话存储）；60 秒内又失败就不再刷，照常抛错交给出错页，免得新版本本身就坏时来回刷成死循环；
 * - 会话存储用不了（隐私模式等）就不自动刷新，同样交给出错页：宁可让人手动点，也不冒死循环的险；
 * - 只在真要刷新时才取消事件；不刷新时不动它，错误照常往下走。
 * 开发站（vite dev）不走预加载助手，不会发这个事件。
 */
export const STALE_CHUNK_RELOAD_KEY = "petsoul:stale-chunk-reload-at";
export const STALE_CHUNK_RELOAD_GAP_MS = 60_000;

type ReloadWindow = Pick<Window, "addEventListener" | "removeEventListener" | "sessionStorage"> & { location: Pick<Location, "reload"> };

export function installStaleChunkReload(win: ReloadWindow = window, now: () => number = () => Date.now()): () => void {
  const onPreloadError = (event: Event) => {
    let last = 0;
    try {
      last = Number(win.sessionStorage.getItem(STALE_CHUNK_RELOAD_KEY)) || 0;
      if (now() - last < STALE_CHUNK_RELOAD_GAP_MS) return;
      win.sessionStorage.setItem(STALE_CHUNK_RELOAD_KEY, String(now()));
    } catch {
      return;
    }
    event.preventDefault();
    win.location.reload();
  };
  win.addEventListener("vite:preloadError", onPreloadError);
  return () => win.removeEventListener("vite:preloadError", onPreloadError);
}
